import '@fontsource-variable/exo-2';
import '@fontsource-variable/inter';
import {
    ArrowRight,
    ArrowUpRight,
    BriefcaseBusiness,
    Building2,
    Check,
    ChevronLeft,
    ChevronRight,
    createIcons,
    Factory,
    FilePlus,
    FileSearch,
    FileText,
    Gavel,
    Globe,
    Headset,
    LayoutDashboard,
    LogIn,
    MapPin,
    MousePointer2,
    Newspaper,
    Package,
    PackageSearch,
    Pause,
    Play,
    Plus,
    RefreshCw,
    Search,
    ShieldCheck,
    Star,
    Store,
    Truck,
    UserRound,
    Wrench,
} from 'lucide';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../css/wop/home.css';
import { HeroStage } from './wop-hero/HeroStage';
import type { HeroProps } from './wop-hero/types';
import { initCoverflows } from './wop/coverflow';
import { OilRig } from './wop/icons';
import { initShell } from './wop/shell';

createIcons({
    icons: {
        ArrowRight,
        ArrowUpRight,
        BriefcaseBusiness,
        Building2,
        Check,
        ChevronLeft,
        ChevronRight,
        Factory,
        OilRig,
        FilePlus,
        FileSearch,
        FileText,
        Gavel,
        Globe,
        Headset,
        LayoutDashboard,
        LogIn,
        MapPin,
        MousePointer2,
        Newspaper,
        Package,
        PackageSearch,
        Pause,
        Play,
        Plus,
        RefreshCw,
        Search,
        ShieldCheck,
        Star,
        Store,
        Truck,
        UserRound,
        Wrench,
    },
});

initShell();
initCoverflows();

const stage = document.getElementById('wop-hero-stage');
const propsScript = document.getElementById('wop-hero-props');

if (stage && propsScript?.textContent) {
    const props = JSON.parse(propsScript.textContent) as HeroProps;

    createRoot(stage).render(
        <StrictMode>
            <HeroStage {...props} />
        </StrictMode>,
    );
}
